import BillDiscountsListPopoverForm from "@/app/components/payment/BillDiscountsListPopoverForm.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class BillDiscountsListPopover extends VueContentPopover {
    constructor(onDiscountRemoved: () => void) {
        super({ popoverClass: "bill-discounts-list-popover", fullscreen: false, flexHeight: true, condensed: true });

        const props = {
            onClose: () => this.hide(),
            onDiscountRemoved: onDiscountRemoved,
        };
        this.initComponent(BillDiscountsListPopoverForm, props);
    }
}
